import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';


function wherenext() {
    
   
    const wherenext_block = document.querySelector('[data-block="where-next"]');
    if (!wherenext_block) { return; }

    const where_links = document.querySelector('[data-target="where_links"]');
    if (!where_links) { return; }

    const img2 = wherenext_block.querySelector('.img2');
    if (!img2) { return; }

    // Get height of where_links and add 200px
    const linksHeight = where_links.offsetHeight;
    const targetHeight = linksHeight + 200;

    // Set height on img2 and any children
    img2.style.height = `${targetHeight}px`;
    const img2Children = img2.children;
    for (let child of img2Children) {
        child.style.height = `${targetHeight}px`;
    }


    
   
}


export { wherenext }; 